import { useReduxSelector } from '../../../hooks';
import { rootStateBranchSelector } from '../../../utils/rootStateBranchSelector';
import type { MapConfigurationState } from '../slice';

export const mapConfigurationSelector = rootStateBranchSelector('mapConfiguration');

export function useMapConfigurationSelector(): MapConfigurationState {
  return useReduxSelector(mapConfigurationSelector);
}
